import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToolbarTitleService {
  private readonly contextualTitleSubject = new BehaviorSubject<string | null>(
    null,
  );

  readonly contextualTitle$ = this.contextualTitleSubject.asObservable();

  setContextualTitle(title: string | null | undefined): void {
    const trimmedTitle = title?.trim() ?? '';
    this.contextualTitleSubject.next(trimmedTitle.length > 0 ? trimmedTitle : null);
  }

  clearContextualTitle(): void {
    this.contextualTitleSubject.next(null);
  }
}
